/* eslint-disable @typescript-eslint/no-explicit-any */
import { MODELO_IMPUESTO, ModeloImpuestoType } from "api/Types/ModeloImpuesto"
import { DropdownChangeParams } from "primereact/dropdown"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  DROPDOWN_YEARS,
  dateRangesList,
  updateYearInDateRange,
} from "../components/Modelo303/constant"

export const useDetalleImpuesto = () => {
  const storageFilters = JSON.parse(
    sessionStorage.getItem("taxDetailFilters") ?? "{}"
  )
  const [selectedYear, setSelectedYear] = useState(
    storageFilters.selectedYear ?? new Date().getFullYear().toString()
  )
  const [model, setModel] = useState<ModeloImpuestoType>(
    storageFilters.selectedModel ?? MODELO_IMPUESTO.MODELO_303
  )

  const { t } = useTranslation()
  const dateRangesListObject = useMemo(() => {
    return dateRangesList(t, selectedYear)
  }, [t, selectedYear])
  const taxDetailStored = JSON.parse(
    sessionStorage.getItem("taxDetailFilters") ?? "null"
  )
  const [selectedDateRange, setSelectedDateRange] = useState(
    taxDetailStored?.selectedDateRange ?? dateRangesListObject.YEAR.value
  )
  const [yearsOptionList, setyearsOptionList] = useState<string[]>()

  useEffect(() => {
    setyearsOptionList(DROPDOWN_YEARS())
  }, [])

  useEffect(() => {
    const updateFilters = {
      selectedModel: model,
      selectedYear,
      selectedDateRange: {
        min: selectedDateRange.min,
        max: selectedDateRange.max,
      },
    }
    sessionStorage.setItem("taxDetailFilters", JSON.stringify(updateFilters))
  }, [selectedDateRange, model, selectedYear])

  const handleYearSelection = (e: DropdownChangeParams) => {
    setSelectedYear(e.value)
    setSelectedDateRange(updateYearInDateRange(e.value, selectedDateRange))
  }

  const handleRangeDateSelection = (e: DropdownChangeParams) => {
    setSelectedDateRange(e.value)
  }

  return {
    selectedYear,
    model,
    setModel,
    selectedDateRange,
    yearsOptionList,
    handleYearSelection,
    handleRangeDateSelection,
  }
}
